export enum InventoryStatuses {
    Active = 'Active',
    TempOutOfStock = 'Temporarily out of stock',
    ComingSoon = 'Coming Soon',
    SoldOut = 'Sold Out',
    FreePromo = 'Free Promo',
    DoNotDisplay = 'Do Not Display',
    Inactive = 'Inactive',
    PreOrder = 'Pre Order'
}
